import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Input,
  InputAdornment,
  MenuItem,
  Radio,
  Select,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import EditText from "../../../components/EditText";
import SelectDateModal from "../../../Modals/selectDate";
import SelectTimeSlotModal from "../../../Modals/SelectTimeSimple";
import { useLazyGetSubjectsAndCategoryQuery } from "../../../service/auth";
import {
  useGetClassListQuery,
  useGetTutorListQuery,
} from "../../../service/tutorApi";
import {
  useAddClassMutation,
  useGetClassesByIdQuery,
  useUpdateClassByIdMutation,
} from "../../../service/class";
import dayjs, { Dayjs } from "dayjs";
import { TutorLayout } from "../../../layout/tutorLayout";
import {
  CLASS_PAYMENT,
  CLASS_SETTING,
  CLASS_TYPE,
  CLASS_TYPE2,
  Class_Variables,
  ClassMode,
  GRADE_TYPE_NAME,
  RECURRENCE_TYPE,
  TYPE_SUBJECT_LISTING,
} from "../../../constants/enums";
import { useFormik } from "formik"; // ✅ Added Formik
import * as Yup from "yup"; // ✅ Added Yup
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
  UploadMedia,
  Uploadpdf,
  UploadVideo,
} from "../../../utils/mediaUpload";
import { showError, showToast } from "../../../constants/toast";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import CancelIcon from "@mui/icons-material/Cancel";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import timezone from "../../../constants/TimeZone";
import { Autocomplete } from "@react-google-maps/api";
import NewSideBarTutor from "../../../components/NewSideBarTutor";
import { toast } from "sonner";
import { useNavigate, useParams } from "react-router-dom";
import { useGetPromoCodeListWithoutPaginationQuery } from "../../../service/promoCode";
import currency from "../../../constants/Currency";
import { convertCurrencyNew } from "../../../utils/currency";
type PromoItem = {
  _id: string;
  name: string;
};


const CreateClassTutor = () => {
  const { id } = useParams();
  const [subjects, setSubjects] = useState<any[]>([]);
  const [getSubjects] = useLazyGetSubjectsAndCategoryQuery();
  const [openDate, setOpenDate] = React.useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const [slots, setSlots] = useState<any>([]);
  const navigate = useNavigate();
  const [timeSlot, setTimeSlot] = useState<any[]>([]);
  const [setting, setSetting] = useState<any>();
  const { data: classList } = useGetClassListQuery({ type: 2 });
  const { data: tutorList } = useGetTutorListQuery({});
  const [createClass] = useAddClassMutation();
  const [editClass] = useUpdateClassByIdMutation();
  const { data: byIdData, isSuccess } = useGetClassesByIdQuery(
    { id: id },
    { skip: !id }
  );
  const { data: promoCode } = useGetPromoCodeListWithoutPaginationQuery({});

  const [selectedDates, setSelectedDates] = useState<string[]>([]);
  const [times, setTimes] = useState<any[]>([]);


  const [selectedTime, setSelectedTime] = useState<Dayjs | null>(null);
  const [openTime, setOpenTime] = React.useState(false);
  const [value, setValue] = useState<Date[]>([]);

  const handlePdfChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const res = await Uploadpdf(file); // assuming this uploads and returns { data: { image: string } }
      const uploadedUrl = res.data?.image;

      if (uploadedUrl) {
        formik.setFieldValue("material", uploadedUrl);
      }
    } catch (error) {
      console.error("Pdf upload failed:", error);
    }
  };

  const handleVideoChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const res = await UploadVideo(file); // assuming this uploads and returns { data: { image: string } }
      const uploadedUrl = res.data?.image;

      if (uploadedUrl) {
        formik.setFieldValue("teaserVideo", uploadedUrl);
      }
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const fetchSubjects = async () => {
    try {
      const res = await getSubjects({
        type: TYPE_SUBJECT_LISTING.TUTOR_SUBJECT,
      }).unwrap();
      if (res?.statusCode == 200) {
        setSubjects(res?.data);
      }
    } catch (error: any) { }
  };

  const onLoad = (autocompleteObj: any) => {
    setAutocomplete(autocompleteObj);
  };
  const onPlaceChanged = async () => {
    if (autocomplete) {
      let place = await (autocomplete as any).getPlace();

      if (place && place.address_components) {
        let address = place.address_components;

        let state,
          city,
          country,
          zip = "";

        address.forEach(function (component: any) {
          let types = component.types;

          if (
            types.indexOf("locality") > -1 ||
            types.indexOf("administrative_area_level_3") > -1
          ) {
            city = component.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        // captureSatelliteView(lat, lng);
        formik.setFieldValue("address", city + "," + country);
        formik.setFieldValue("latitude", lat || "");
        formik.setFieldValue("longitude", lng || "");
      }
    }
  };

  const generateRecurringSchedule = (
    selectedDays: any, // ['Tue', 'Thu']
    selectedSlots: any, // [{start, end}]
    repeatEvery: any, // number of weeks between sessions
    numOfWeeks: any, // optional if endDate is provided
    endDate: any // optional ISO string (e.g., '2025-08-31T00:00:00Z')
  ) => {
    console.log(
      selectedDays,
      selectedSlots,
      repeatEvery,
      numOfWeeks,
      endDate,
      "props"
    );
    const dayMap: any = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6,
    };
    const schedule: any = [];
    if (
      !Array.isArray(selectedDays) ||
      selectedDays?.length === 0 ||
      !repeatEvery
    ) {
      toast.error("Missing required inputs");
      return [];
    }
    const untilDate = endDate ? moment.utc(endDate).endOf("day") : null;
    selectedDays?.forEach((dayKey) => {
      const dayIndex: any = dayMap[dayKey];
      selectedSlots?.forEach((slot: any) => {
        const slotStart = moment.utc(slot.start);
        const slotEnd = moment.utc(slot.end);
        const duration = slotEnd.diff(slotStart);
        // Start from first desired weekday after slotStart
        let firstDay = moment.utc(slotStart).day(dayIndex);
        if (firstDay.isBefore(slotStart)) {
          firstDay.add(7, "days");
        }
        let week = 0;
        while (true) {
          const sessionStart = moment.utc(firstDay).add(week * 7, "days");
          const sessionEnd = moment
            .utc(sessionStart)
            .add(duration, "milliseconds");
          // Stop if endDate is given and we've passed it
          if (untilDate && sessionStart.isAfter(untilDate)) break;
          // Stop if numOfWeeks is given and we've reached limit
          if (!untilDate && week >= numOfWeeks) break;
          schedule.push({
            date: sessionStart.toISOString(),
            startTime: sessionStart.toISOString(),
            endTime: sessionEnd.toISOString(),
          });
          week += repeatEvery;
        }
      });
    });
    console.log(schedule, "schedule");

    return schedule;
  };

  const minimalValidationSchema = Yup.object({
    subject: Yup.string().required("Subject is required"),
    topic: Yup.string().required("Topic is required"),
    description: Yup.string().min(10).required("Description is required"),
  });

  const fullValidationSchema = Yup.object({
    subject: Yup.string().required("Subject is required"),
    topic: Yup.string().required("Topic is required"),
    description: Yup.string().min(10).required("Description is required"),
    learningObjects: Yup.string().required("Learning Objects is required"),
    learningOutcomesAll: Yup.string(),
    learningOutcomesMost: Yup.string(),
    learningOutcomesSome: Yup.string(),
    thumbnail: Yup.string().required("Thumbnail is required"),
    teaserVideo: Yup.string().required("Teaser Video is required"),
    timeZone: Yup.string().required("TimeZone is required"),
    gradeOption: Yup.string().required("Grade is required"),
    daysOfWeek: Yup.array()
      .of(Yup.string())
      .min(1, "Days are required")
      .required("Days are required"),
    classType2: Yup.string().required("Class type is required"),
    seatLimit: Yup.string().required("Seat Limit is required"),
    currency: Yup.string().required("Currency is required"),
    typeOfClass: Yup.string().required("Class type is required"),
    material: Yup.string().required("Material is required"),
    searchTags: Yup.string().required("Search Tags is required"),
    instructionLanguage: Yup.string().required(
      "Instruction Language is required"
    ),
    sessionDuration: Yup.string().required("Session duration is required"),
  });

  const formik = useFormik({

    initialValues: {
      subject: "",
      topic: "",
      description: "",
      learningObjects: "",
      learningOutcomesAll: "",
      learningOutcomesMost: "",
      learningOutcomesSome: "",
      thumbnail: "",
      teaserVideo: "",
      selectedDates: "",
      selectedSlots: "",
      timeZone: "",
      gradeOption: "",
      feePerStudent: "",
      promoCode: [],
      seatLimit: "",
      typeOfClass: "",
      coTeacher: "",
      material: "",
      searchTags: "",
      instructionLanguage: "",
      customNotes: "",
      allowPrivateClass: false,
      latitude: 0,
      longitude: 0,
      address: "",
      setting: "",
      sessionDuration: "60",
      multiTimeSelect: false,
      daysOfWeek: [],
      repeatWeek: "1",
      continueWeek: "1",
      endDate: "",
      duration: "1",
      freeLesson: false,
      paymentType: CLASS_PAYMENT.SESSION,
      classType2: "",
      currency: ""
    },
    validationSchema:
      setting == CLASS_SETTING.DRAFT
        ? minimalValidationSchema
        : fullValidationSchema,


    onSubmit: async (values) => {

      let usdPrice: any = formik.values.feePerStudent;
      if ((id && formik.values.feePerStudent !== byIdData?.data?.fees) || (!id && formik.values.feePerStudent)) {
        usdPrice = await getConverted();
      }

      const classSlots =
        setting == CLASS_SETTING.PUBLISH
          ? generateRecurringSchedule(
            formik.values.daysOfWeek,
            timeSlot,
            formik.values.repeatWeek,
            formik.values.duration === "1" && formik.values.continueWeek
              ? Number(formik.values.continueWeek)
              : null,
            formik.values.duration === "2" && formik.values.endDate
              ? formik.values.endDate
              : null
          )
          : [];

      if (!classSlots?.length && setting == CLASS_SETTING.PUBLISH) {
        toast.error("Please select a valid schedule");
        return;
      }

      const body = {
        ...(values.subject ? { subjectId: values.subject } : {}),
        topic: values.topic,
        description: values.description,
        ...(values.currency ? { currency: values?.currency } : {}),
        ...(values.gradeOption ? { classId: Number(values.gradeOption) } : {}),
        ...(values.learningObjects
          ? { objective: values.learningObjects }
          : {}),
        ...(values.learningOutcomesSome
          ? { someOutcome: values.learningOutcomesSome }
          : {}),
        ...(values.learningOutcomesAll
          ? { allOutcome: values.learningOutcomesAll }
          : {}),
        ...(values.learningOutcomesMost
          ? { mostOutcome: values.learningOutcomesMost }
          : {}),
        ...(values.thumbnail ? { thumbnail: values.thumbnail } : {}),
        ...(values.teaserVideo ? { teaser: values.teaserVideo } : {}),
        ...(values.feePerStudent ? { fees: values.feePerStudent } : {}),
        ...(values.feePerStudent ? { usdPrice: Number(usdPrice?.converted) ||values.feePerStudent } : {}),
        ...(values.seatLimit ? { seats: values.seatLimit } : {}),
        ...(values.coTeacher ? { coTutorId: values.coTeacher } : {}),
        ...(values.searchTags?.length
          ? { searchTags: values.searchTags?.split(",") }
          : {}),
        ...(values.instructionLanguage
          ? { language: Number(values.instructionLanguage) }
          : {}),
        ...(values.customNotes ? { notes: values.customNotes } : {}),
        ...(values.typeOfClass ? { classMode: values.typeOfClass } : {}),
        ...(values.timeZone ? { timezone: values.timeZone } : {}),
        ...(values.material ? { material: [values.material] } : {}),
        canBePrivate: values.allowPrivateClass,
        ...(classSlots?.length ? { classSlots: classSlots } : {}),
        ...(values?.promoCode?.length ? { promoCodeId: values.promoCode } : {}),
        ...(formik.values.address &&
          (Number(formik.values.typeOfClass) == ClassMode.OFFLINE ||
            Number(formik.values.typeOfClass) === ClassMode.HYBRID)
          ? { address: formik.values.address }
          : {}),
        ...(formik.values.longitude &&
          (Number(formik.values.typeOfClass) == ClassMode.OFFLINE ||
            Number(formik.values.typeOfClass) === ClassMode.HYBRID)
          ? { longitude: formik.values.longitude }
          : {}),
        ...(formik.values.latitude &&
          (Number(formik.values.typeOfClass) == ClassMode.OFFLINE ||
            Number(formik.values.typeOfClass) === ClassMode.HYBRID)
          ? { latitude: formik.values.latitude }
          : {}),

        setting: setting,
        duration: values.repeatWeek,
        isFreeLesson: values.freeLesson,
        ...(values.freeLesson ? {} : { payment: Number(values.paymentType) }),

        ...(values.classType2
          ? { typeOfClass: Number(values.classType2) }
          : {}),

        ...(formik.values.endDate
          ? {
            endDate: moment(formik.values.endDate)
              .startOf("day")
              .utc()
              .toISOString(),
          }
          : {}),
        ...(classSlots?.[0]?.date ? { startDate: classSlots?.[0]?.date } : {}),
      };
      console.log(body, "body");
      return;
      try {
        // if (id) {
        //   const res = await editClass({ id: id, body: body }).unwrap();
        //   if (res?.statusCode === 200) {
        //     showToast("Class updated successfully");
        //     navigate("/tutor/classes");
        //   }
        // } else {
        //   const res = await createClass(body).unwrap();
        //   if (res?.statusCode === 200) {
        //     if (setting == String(CLASS_SETTING.DRAFT)) {
        //       showToast("Class added in Draft successfully");
        //       navigate("/tutor/classes/drafts");
        //     } else {
        //       showToast("Class created successfully");
        //       navigate("/tutor/classes");
        //       formik.resetForm();
        //     }
        //   }
        // }
      } catch (error: any) {
        showError(error?.data?.message || "")
      }
    },
  });

  const handleDaysChange = (event: any, newValue: any) => {
    if (!formik.values.multiTimeSelect) {
      formik.setFieldValue("daysOfWeek", newValue ? [newValue] : []);
    } else {
      formik.setFieldValue("daysOfWeek", newValue || []);
    }
  };

  // const handleAddTime = (time: any) => {
  //     if (!time) return;
  //     const utcTime = time.utc().toISOString();
  //     setTimes((prev) => [...prev, utcTime]);
  // };

  const handleAddTime = (startTime: any) => {
    if (!startTime) return;
    let dur = Number(formik.values.sessionDuration);

    const endTime = startTime.clone().add(dur, "minutes");
    const startUtc = startTime.utc().toISOString();
    const endUtc = endTime.utc().toISOString();

    const newSlot = { start: startUtc, end: endUtc };

    const existingSlots = timeSlot; // now properly typed as Slot[]

    const isConflict = existingSlots.some((slot) => {
      return (
        (startUtc >= slot.start && startUtc < slot.end) || // new start inside existing
        (endUtc > slot.start && endUtc <= slot.end) || // new end inside existing
        (startUtc <= slot.start && endUtc >= slot.end) // new covers existing
      );
    });

    if (isConflict) {
      toast.error("Conflict detected!");
      return;
    }

    setTimeSlot([...existingSlots, newSlot]);
  };

  const formatDateSlots = (
    selectedDates: string[],
    slotTime: string[] // each is UTC ISO string, but we only need time part
  ) => {
    const result: { date: string; startTime: string; endTime: string }[] = [];

    selectedDates.forEach((dateStr) => {
      const baseDateUtc = dayjs.utc(dateStr).startOf("day"); // midnight UTC

      slotTime.forEach((slotUtcString) => {
        const slotTimeObj = dayjs.utc(slotUtcString);
        const startHour = slotTimeObj.hour();
        const startMinute = slotTimeObj.minute();

        // Combine selectedDate + slot time in UTC
        const startTime = dayjs
          .utc(dateStr)
          .hour(startHour)
          .minute(startMinute)
          .second(0)
          .millisecond(0);

        const endTime = startTime.add(1, "hour");
        result.push({
          date: baseDateUtc.toISOString(), // UTC midnight of selected date
          startTime: startTime.toISOString(), // correct UTC datetime
          endTime: endTime.toISOString(),
        });
      });
    });

    return result;
  };
  const handleCloseModal2 = () => {
    setOpenDate(false);
  };
  const handleCloseModal3 = () => {
    setOpenTime(false);
  };
  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const res = await UploadMedia(file); // assuming this uploads and returns { data: { image: string } }
      const uploadedUrl = res.data?.image;

      if (uploadedUrl) {
        formik.setFieldValue("thumbnail", uploadedUrl);
      }
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const getConverted = async () => {
    const result = await convertCurrencyNew({
      baseCurrency: formik.values.currency,
      targetCurrency: 'USD',
      amount: Number(formik.values.feePerStudent),
    });

    if (result) {
      return result;
    } else {
      return (formik.values.feePerStudent);
    }
  };

  useEffect(() => {
    if (isSuccess) {
      formik.setFieldValue("subject", byIdData?.data?.subjects?._id || "");
      formik.setFieldValue("topic", byIdData?.data?.topic || "");
      formik.setFieldValue("description", byIdData?.data?.description || "");
      formik.setFieldValue("learningObjects", byIdData?.data?.objective || "");
      formik.setFieldValue(
        "learningOutcomesAll",
        byIdData?.data?.allOutcome || ""
      );
      formik.setFieldValue(
        "learningOutcomesMost",
        byIdData?.data?.mostOutcome || ""
      );
      formik.setFieldValue(
        "learningOutcomesSome",
        byIdData?.data?.someOutcome || ""
      );
      formik.setFieldValue("thumbnail", byIdData?.data?.thumbnail || "");
      formik.setFieldValue("teaserVideo", byIdData?.data?.teaser || "");
      formik.setFieldValue("timeZone", byIdData?.data?.timeZone || "");
      formik.setFieldValue("gradeOption", byIdData?.data?.classId || "");
      formik.setFieldValue("feePerStudent", byIdData?.data?.fees || "");
      formik.setFieldValue("seatLimit", byIdData?.data?.seats || "");
      formik.setFieldValue("typeOfClass", byIdData?.data?.classMode || "");
      formik.setFieldValue("coTeacher", byIdData?.data?.coTutor?._id || "");
      formik.setFieldValue("material", byIdData?.data?.material?.[0] || "");
      formik.setFieldValue(
        "instructionLanguage",
        byIdData?.data?.language || ""
      );
      formik.setFieldValue("customNotes", byIdData?.data?.notes || "");
      formik.setFieldValue(
        "allowPrivateClass",
        byIdData?.data?.canBePrivate || ""
      );
      formik.setFieldValue("latitude", byIdData?.data?.latitude || "");
      formik.setFieldValue("longitude", byIdData?.data?.longitude || "");
      formik.setFieldValue("address", byIdData?.data?.address || "");
      formik.setFieldValue("classType2", byIdData?.data?.typeOfClass || "");
      formik.setFieldValue("repeatWeek", byIdData?.data?.duration || "");
      formik.setFieldValue("paymentType", byIdData?.data?.payment || "");
      formik.setFieldValue("currency", byIdData?.data?.currency || "");
    }
  }, [isSuccess]);



  useEffect(() => {
    fetchSubjects();
  }, []);

  return (
    <>
      <TutorLayout className="role-layout">
        <main className="content">
          <section className="uh_spc pSearchResult_sc home_wrp">
            <div className="conta_iner v2">
              <div className="gap_m grid_2">
                <NewSideBarTutor />
                <div className="role_body rt_v2 abt_profile_sc ">
                  <div
                    style={{ margin: "0" }}
                    className="card_box addvideo_upload form_class"
                  >
                    <form onSubmit={formik.handleSubmit}>
                      <div className="title_md">
                        <h2>Create class</h2>
                      </div>
                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Select
                          name="subject"
                          value={formik.values.subject}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Select Subject
                          </MenuItem>
                          {subjects?.map((item) => {
                            return (
                              <MenuItem key={item?._id} value={item?._id}>
                                {item?.name || "-"}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {formik.touched.subject && formik.errors.subject && (
                          <Typography color="error" fontSize={12}>
                            {formik.errors.subject as string}
                          </Typography>
                        )}
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Input
                          fullWidth
                          placeholder="Enter Topic"
                          name="topic"
                          value={formik.values.topic}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.topic && formik.errors.topic && (
                          <Typography color="error" fontSize={12}>
                            {formik.errors.topic}
                          </Typography>
                        )}
                      </div>
                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        {/* <Input
                                                fullWidth
                                                placeholder="Enter Description"
                                                name="description"
                                                value={formik.values.description}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                minRows={4}
                                                multiline
                                            /> */}
                        <label>Description</label>
                        <EditText
                          content={formik.values.description}
                          setContent={(value) =>
                            formik.setFieldValue("description", value)
                          }
                        />
                        {formik.touched.description &&
                          formik.errors.description && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.description}
                            </Typography>
                          )}
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <label htmlFor="learningObjects">
                          Learning Objectives
                        </label>
                        <Input
                          fullWidth
                          placeholder="What will students Learn"
                          name="learningObjects"
                          value={formik.values.learningObjects}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          minRows={4}
                          multiline
                        />
                        {formik.touched.learningObjects &&
                          formik.errors.learningObjects && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.learningObjects}
                            </Typography>
                          )}
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <label htmlFor="learningOutcomes">
                          Learning Outcomes
                        </label>

                        <Input
                          fullWidth
                          placeholder="All learners will be able to.."
                          name="learningOutcomesAll"
                          value={formik.values.learningOutcomesAll}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          minRows={4}
                          multiline
                        />
                        {formik.touched.learningOutcomesAll &&
                          formik.errors.learningOutcomesAll && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.learningOutcomesAll}
                            </Typography>
                          )}
                      </div>
                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <label htmlFor="MostLearnersWillBeAbleTo">
                          Most learners
                        </label>
                        <Input
                          fullWidth
                          placeholder="Most learners will be able to.."
                          name="learningOutcomesMost"
                          value={formik.values.learningOutcomesMost}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          minRows={4}
                          multiline
                        />
                        {formik.touched.learningOutcomesMost &&
                          formik.errors.learningOutcomesMost && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.learningOutcomesMost}
                            </Typography>
                          )}
                      </div>
                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <label htmlFor="SomeLearnersWillBeAbleTo">
                          Some learners
                        </label>

                        <Input
                          fullWidth
                          placeholder="Some learners will be able to.."
                          name="learningOutcomesSome"
                          value={formik.values.learningOutcomesSome}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          minRows={4}
                          multiline
                        />
                        {formik.touched.learningOutcomesSome &&
                          formik.errors.learningOutcomesSome && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.learningOutcomesSome}
                            </Typography>
                          )}
                      </div>
                      {/* upload file */}
                      <div className="conrtol_group">
                        <label>Class Thumbnail</label>


                        {formik.values.thumbnail ? (
                          <div className="ovr_flow">
                            <label htmlFor="UploadClassThumbnail">
                              Upload Class Thumbnail
                            </label>

                            <div className="upload_file">
                              <figure>
                                <img
                                  src={
                                    formik.values.thumbnail ||
                                    `/static/images/emili.png`
                                  }
                                  alt="emili"
                                />
                                <figcaption
                                  onClick={() =>
                                    formik.setFieldValue("thumbnail", "")
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <CancelIcon />
                                </figcaption>
                              </figure>
                            </div>
                          </div>
                        ) : (
                          <div className="upload_file">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleImageChange}
                            />
                            <DriveFolderUploadIcon />
                            <p>Upload Images</p>

                            {/* ✅ Image upload validation message */}
                            {formik.errors.thumbnail &&
                              typeof formik.errors.thumbnail === "string" && (
                                <Typography color="error" fontSize={12}>
                                  {formik.errors.thumbnail}
                                </Typography>
                              )}
                          </div>
                        )}

                        {formik.values.teaserVideo ? (
                          <div className="ovr_flow">
                            <label htmlFor="UploadTeaserVideo">
                              Upload Teaser Video
                            </label>
                            <div className="upload_file">
                              <figure>
                                <video
                                  controls
                                  src={
                                    formik.values.teaserVideo ||
                                    `/static/images/emili.png`
                                  }
                                />
                                <figcaption
                                  onClick={() =>
                                    formik.setFieldValue("teaserVideo", "")
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <CancelIcon />
                                </figcaption>
                              </figure>
                            </div>
                          </div>
                        ) : (
                          <div className="upload_file ">
                            <input
                              type="file"
                              accept="video/*"
                              onChange={handleVideoChange}
                            />
                            <DriveFolderUploadIcon />
                            <p>Upload Video</p>

                            {/* ✅ Image upload validation message */}
                            {formik.errors.teaserVideo &&
                              typeof formik.errors.teaserVideo === "string" && (
                                <Typography color="error" fontSize={12}>
                                  {formik.errors.teaserVideo}
                                </Typography>
                              )}
                          </div>
                        )}
                      </div>
                      {/* <h3>Date & Time</h3>
                                        <div className="control_group ">
                                            <TextField
                                                fullWidth
                                                hiddenLabel
                                                defaultValue="Select Date"
                                                placeholder="Select Date"
                                                InputProps={{
                                                    readOnly: true,
                                                    startAdornment: (
                                                        <InputAdornment position="end">
                                                            <CalendarTodayOutlinedIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                onClick={() => setOpenDate(true)}
                                            ></TextField>
                                        </div>
                                        {selectedDates?.length > 0 && (
                                            <ul className='cal_fdx'>
                                                <li>
                                                    <div className="selected-dates-container">
                                                        {selectedDates?.map((item, index) => (
                                                            <p className="available" key={index}>
                                                                {item}
                                                            </p>
                                                        ))}
                                                        <figure onClick={() => { setSelectedDates([]); setValue([]); setSlots([]) }}>
                                                            <CloseIcon sx={{ fontSize: "17px" }} />
                                                        </figure>
                                                    </div>
                                                </li>


                                            </ul>
                                        )} */}

                      {/* <div className="control_group ">
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <TimePicker
                                                    value={selectedTime}
                                                    onChange={(time) => setSelectedTime(time)}
                                                    onAccept={(time) => handleAddTime(time)}

                                                />
                                            </LocalizationProvider>
                                        </div> */}

                      {/* {times?.length > 0 && (
                                            <ul className='cal_fdx'>
                                                <li>
                                                    <div className="selected-dates-container">
                                                        {times?.map((item, index) => (
                                                            <p className="available" key={index}>
                                                                {moment(item).format("hh:mm a")}
                                                            </p>
                                                        ))}
                                                        <figure onClick={() => { setTimes([]); setSlots([]) }}>
                                                            <CloseIcon sx={{ fontSize: "17px" }} />
                                                        </figure>
                                                    </div>
                                                </li>


                                            </ul>
                                        )} */}

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Select
                          name="gradeOption"
                          value={formik.values.gradeOption}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Select level's
                          </MenuItem>
                          {classList?.data?.[0]?.classes?.map((item: any) => {
                            return (
                              <MenuItem key={item?._id} value={item}>
                                {GRADE_TYPE_NAME[Number(item)]}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {formik.touched.gradeOption &&
                          formik.errors.gradeOption && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.gradeOption}
                            </Typography>
                          )}
                      </div>
                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Select
                          name="currency"
                          value={formik.values.currency}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Select Currency
                          </MenuItem>
                          {currency?.map((item: any) => {
                            return (
                              <MenuItem key={item?.id} value={item?.currency}>
                                {item?.title}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {formik.touched.currency &&
                          formik.errors.currency && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.currency}
                            </Typography>
                          )}
                      </div>
                      <Checkbox
                        name="freeLesson"
                        checked={formik.values.freeLesson}
                        onChange={formik.handleChange}
                      />
                      <label>Free session</label>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Input
                          fullWidth
                          placeholder="fee per student.."
                          name="feePerStudent"
                          value={formik.values.feePerStudent}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={formik.values.freeLesson ? true : false}
                        />
                        {formik.touched.feePerStudent &&
                          formik.errors.feePerStudent && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.feePerStudent}
                            </Typography>
                          )}
                      </div>

                      <div className='control_group'>
                        <label>Payment Type</label>
                        <div className='gap_p'>
                          <div className="control_group w_50">
                            <label>Per Hour</label>
                            <Radio
                              name="paymentType"
                              checked={
                                formik.values.paymentType === CLASS_PAYMENT.PER_HOUR
                              }
                              onChange={() =>
                                formik.setFieldValue(
                                  "paymentType",
                                  CLASS_PAYMENT.PER_HOUR
                                )
                              }
                            />
                          </div>
                          <div className="control_group w_50">
                            <label>Per Session</label>
                            <Radio
                              name="paymentType"
                              checked={
                                formik.values.paymentType === CLASS_PAYMENT.SESSION
                              }
                              onChange={() =>
                                formik.setFieldValue(
                                  "paymentType",
                                  CLASS_PAYMENT.SESSION
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Select
                          name="promoCode"
                          multiple
                          value={formik.values.promoCode}
                          onChange={(e) => {
                            const { value } = e.target;
                            formik.setFieldValue("promoCode", typeof value === 'string' ? value.split(',') : value);
                          }}
                          onBlur={formik.handleBlur}
                          fullWidth
                          displayEmpty
                          renderValue={(selected: any) => {
                            if (!selected?.length) return "Select Promo code";
                            const selectedNames = (promoCode?.data as PromoItem[])?.filter((item: any) =>
                              selected?.includes(item?._id || "")
                            ).map((item) => item?.name);
                            return selectedNames?.join(", ");
                          }}
                        >
                          <MenuItem value="" disabled>
                            Select Promo code
                          </MenuItem>
                          {promoCode?.data?.length
                            ? promoCode?.data?.map((item: any) => {
                              return (
                                <MenuItem value={item?._id}>
                                  {item?.name || ""}
                                </MenuItem>
                              );
                            })
                            : null}
                        </Select>
                        {formik.touched.promoCode &&
                          formik.errors.promoCode && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.promoCode}
                            </Typography>
                          )}
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Input
                          fullWidth
                          placeholder="Seat limit"
                          name="seatLimit"
                          value={formik.values.seatLimit}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.seatLimit &&
                          formik.errors.seatLimit && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.seatLimit}
                            </Typography>
                          )}
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Select
                          name="typeOfClass"
                          value={formik.values.typeOfClass}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Select class type
                          </MenuItem>
                          <MenuItem value={ClassMode.ONLINE}>Online</MenuItem>
                          <MenuItem value={ClassMode.OFFLINE}>Offline</MenuItem>
                          <MenuItem value={ClassMode.HYBRID}>Hybrid</MenuItem>
                        </Select>
                        {formik.touched.typeOfClass &&
                          formik.errors.typeOfClass && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.typeOfClass}
                            </Typography>
                          )}
                      </div>
                      {formik.values.typeOfClass == String(ClassMode.OFFLINE) ||
                        formik.values.typeOfClass == String(ClassMode.HYBRID) ? (
                        <Autocomplete
                          onLoad={onLoad}
                          onPlaceChanged={() => onPlaceChanged()}
                        >
                          <div className="form_control">
                            <label>Address</label>
                            <TextField
                              id="standard-basic"
                              variant="standard"
                              name="address"
                              value={formik.values.address}
                              fullWidth
                              hiddenLabel
                              placeholder="Enter address "
                              onBlur={formik.handleBlur}
                              helperText={
                                formik.touched.address &&
                                (formik.errors.address as string)
                              }
                              onChange={formik.handleChange}
                            ></TextField>
                          </div>
                        </Autocomplete>
                      ) : null}

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Select
                          name="coTeacher"
                          value={formik.values.coTeacher}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Select co-teacher
                          </MenuItem>
                          {tutorList?.data?.map((item: any) => {
                            return (
                              <MenuItem key={item?._id} value={item?._id}>
                                {item?.name || ""}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {formik.touched.coTeacher &&
                          formik.errors.coTeacher && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.coTeacher}
                            </Typography>
                          )}
                      </div>

                      {formik.values.material ? (
                        <div className="ovr_flow">
                          <div className="upload_file">
                            <figure>
                              <img
                                src={`/static/images/pdf_icon.svg`}
                                alt="emili"
                              />
                              <figcaption
                                onClick={() =>
                                  formik.setFieldValue("material", "")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <CancelIcon />
                              </figcaption>
                            </figure>
                            x
                          </div>
                        </div>
                      ) : (
                        <div className="upload_file">
                          <label htmlFor="UploadMaterial">
                            Upload material
                          </label>
                          <input
                            type="file"
                            accept="application/pdf"
                            onChange={handlePdfChange}
                          />
                          <DriveFolderUploadIcon />
                          <p>Upload Images</p>

                          {/* ✅ Image upload validation message */}
                          {formik.errors.material &&
                            typeof formik.errors.material === "string" && (
                              <Typography color="error" fontSize={12}>
                                {formik.errors.material}
                              </Typography>
                            )}
                        </div>
                      )}

                      <div
                      >
                        <Typography variant="h6" mb={2} fontWeight={500}>
                          Recurrence
                        </Typography>
                      </div>
                      <div className="control_group">
                        <label>Session Duration</label>
                        <FormControl fullWidth>
                          <Select
                            value={formik.values.sessionDuration}
                            onChange={formik.handleChange}
                            displayEmpty
                            name='sessionDuration'
                            sx={{ mt: 1 }}
                          >
                            <MenuItem value={"30"}>30 minutes</MenuItem>
                            <MenuItem value={"45"}>45 minutes</MenuItem>
                            <MenuItem value={"60"}>60 minutes</MenuItem>
                            <MenuItem value={"90"}>90 minutes</MenuItem>
                            <MenuItem value={"120"}>120 minutes</MenuItem>
                          </Select>
                        </FormControl>
                      </div>


                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Select
                          name="timeZone"
                          value={formik.values.timeZone}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Select timezone
                          </MenuItem>
                          {timezone?.map((item: any) => {
                            return (
                              <MenuItem
                                key={item?.label}
                                value={item?.value}
                              >
                                {item?.label || "-"}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {formik.touched.timeZone &&
                          formik.errors.timeZone && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.timeZone}
                            </Typography>
                          )}
                      </div>

                      <FormControlLabel
                        control={
                          <Checkbox
                            name="multiTimeSelect"
                            checked={formik.values.multiTimeSelect}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "multiTimeSelect",
                                e.target.checked
                              );
                              if (e.target.checked === false) {
                                formik.setFieldValue("daysOfWeek", []);
                              }
                            }}
                          />
                        }
                        label="Multi-day selection mode"
                        sx={{ mt: 2 }}
                      />

                      <div className='control_group days_week'>
                        <label>Days of the Week</label>
                        <ToggleButtonGroup
                          value={formik.values.daysOfWeek}
                          onChange={handleDaysChange}
                          aria-label="days of the week"
                          sx={{ mt: 1 }}
                          exclusive={!formik.values.multiTimeSelect} // single select if false
                        >
                          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
                            <ToggleButton sx={{
                              '&.Mui-selected': {
                                backgroundColor: '#4caf50', // your green
                                color: '#fff',
                                '&:hover': {
                                  backgroundColor: '#43a047',
                                },
                              }
                            }} key={day} value={day}>{day}</ToggleButton>
                          ))}
                        </ToggleButtonGroup>
                        {formik.touched.daysOfWeek && formik.errors.daysOfWeek && (
                          <Typography color="error" fontSize={12}>
                            {formik.errors.daysOfWeek}
                          </Typography>
                        )}
                      </div>

                      <div className="control_group ">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            value={selectedTime}
                            // onChange={(time) => setSelectedTime(time)}
                            onAccept={(time) => handleAddTime(time)}
                          />
                        </LocalizationProvider>
                      </div>

                      {timeSlot?.length > 0 && (
                        <ul className="cal_fdx">
                          <li>
                            <div className="selected-dates-container">
                              {timeSlot?.map((item, index) => (
                                <p className="available" key={index}>
                                  {moment(item?.start).format("hh:mm a") +
                                    "-" +
                                    moment(item?.end).format("hh:mm a")}
                                </p>
                              ))}
                              <figure
                                onClick={() => {
                                  setTimeSlot([]);
                                  setTimes([]);
                                }}
                              >
                                <CloseIcon sx={{ fontSize: "17px" }} />
                              </figure>
                            </div>
                          </li>
                        </ul>
                      )}

                      <div>
                        <label>Recurrence Interval</label>
                        <div
                          style={{ display: "flex", alignItems: "center", gap: '10px' }}
                        >
                          <Typography>Repeat every</Typography>
                          <TextField
                            type="number"
                            size="small"
                            name="repeatWeek"
                            value={formik.values.repeatWeek}
                            onChange={formik.handleChange}
                            inputProps={{ min: 1 }}
                            sx={{ width: 80 }}
                          />
                          <Typography>week</Typography>
                        </div>
                      </div>

                      <div>
                        <label>Duration</label>
                        <div>
                          <FormControlLabel
                            control={
                              <Radio
                                name="duration"
                                checked={formik.values.duration === "1"}
                                onChange={() =>
                                  formik.setFieldValue("duration", "1")
                                }
                              />
                            }
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                Continue for
                                <TextField
                                  type="number"
                                  size="small"
                                  name="continueWeek"
                                  disabled={formik.values.duration === "2"}
                                  value={formik.values.continueWeek}
                                  onChange={formik.handleChange}
                                  inputProps={{ min: 1 }}
                                  sx={{ width: 80 }}
                                />
                                weeks total
                              </div>
                            }
                          />
                          <FormControlLabel
                            control={
                              <Radio
                                name="duration"
                                checked={formik.values.duration === "2"}
                                onChange={() =>
                                  formik.setFieldValue("duration", "2")
                                }
                              />
                            }
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                End on
                                <TextField
                                  type="date"
                                  size="small"
                                  name="endDate"
                                  value={formik.values.endDate}
                                  onChange={formik.handleChange}
                                  disabled={formik.values.duration === "1"}
                                />
                              </div>
                            }
                          />
                        </div>
                      </div>

                      <div>
                        <Typography variant="body2" color="text.secondary">
                          Schedule Preview: Select days and times to see
                          schedule preview
                        </Typography>
                      </div>


                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Input
                          fullWidth
                          placeholder="Searchable tags"
                          name="searchTags"
                          value={formik.values.searchTags}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.searchTags &&
                          formik.errors.searchTags && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.searchTags}
                            </Typography>
                          )}
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <Select
                          name="instructionLanguage"
                          value={formik.values.instructionLanguage}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Language of instructions
                          </MenuItem>
                          <MenuItem value="1">English</MenuItem>
                          <MenuItem value="2">Arabic</MenuItem>
                        </Select>
                        {formik.touched.instructionLanguage &&
                          formik.errors.instructionLanguage && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.instructionLanguage}
                            </Typography>
                          )}
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <label>Custom notes</label>
                        {/* <Input
                                                fullWidth
                                                placeholder="Custom notes"
                                                name="customNotes"
                                                value={formik.values.customNotes}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                multiline
                                                minRows={4}

                                            /> */}
                        <EditText
                          content={formik.values.customNotes}
                          setContent={(value) =>
                            formik.setFieldValue("customNotes", value)
                          }
                        />
                        {formik.touched.customNotes &&
                          formik.errors.customNotes && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.customNotes}
                            </Typography>
                          )}
                      </div>

                      <div
                        className="control_group"
                        style={{ marginTop: "15px" }}
                      >
                        <label>Allow for private class</label>
                        <Checkbox
                          name="allowPrivateClass"
                          checked={formik.values.allowPrivateClass}
                          onChange={formik.handleChange}
                        />
                      </div>
                      <div className="control_group">
                        <label id="classType2-label">Class Type</label>
                        <FormControl fullWidth size="small">
                          <Select
                            labelId="classType2-label"
                            id="classType2"
                            name="classType2"
                            label="Class Type"
                            value={formik.values.classType2}
                            onChange={formik.handleChange}
                            displayEmpty
                          >
                            <MenuItem value="">Select class type</MenuItem>
                            <MenuItem value={CLASS_TYPE2.NORMAL}>Normal</MenuItem>
                            <MenuItem value={CLASS_TYPE2.MASTER}>Master</MenuItem>
                            <MenuItem value={CLASS_TYPE2.WORKSHOP}>Workshop</MenuItem>
                            <MenuItem value={CLASS_TYPE2.SEMINAR}>Seminar</MenuItem>
                          </Select>
                          {formik.touched.classType2 && formik.errors.classType2 && (
                            <Typography color="error" fontSize={12}>
                              {formik.errors.classType2}
                            </Typography>
                          )}
                        </FormControl>
                      </div>


                      <div className="btn_group">
                        <button
                          type="button"
                          className="btn primary"
                          onClick={async () => {
                            await setSetting(CLASS_SETTING.DRAFT);
                            formik.submitForm();
                          }}
                        >
                          Save as Draft
                        </button>

                        <button
                          type="button"
                          className="btn primary"
                          onClick={async () => {
                            await setSetting(CLASS_SETTING.PUBLISH);
                            formik.submitForm();
                          }}
                        >
                          Create Class
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <SelectDateModal
          open={openDate}
          onClose={handleCloseModal2}
          setOpen={setOpenDate}
          selectedDates={selectedDates}
          setSelectedDates={setSelectedDates}
          value={value}
          setValue={setValue}
        />
        <SelectTimeSlotModal
          open={openTime}
          onClose={handleCloseModal3}
          selectedDates={selectedDates}
          slots={slots}
          setSlots={setSlots}
        />
      </TutorLayout>
    </>
  );
};

export default CreateClassTutor;
